import { LocalStorageKey } from 'shared/constants/localStorage'
import { useSearchParams } from 'shared/hooks/useSearchParams'
import { lsGetItem } from 'shared/utils/local-storage'

const selectableUsers = lsGetItem(LocalStorageKey.SELECTABLE_USERS) || []

export const useCurrentSelectableUser = () => {
  const [{ user: userId }] = useSearchParams<{ user?: string }>()

  return selectableUsers.find(u => u.id === userId) || null
}
